import { z } from "zod";
/** `p_group_by` отчёта заказов компании — `corp_report_orders` (§4.3). */
export const zReportGroupBy = z.enum(["total", "employee", "month", "day"]);
export const REPORT_GROUP_BY_LABELS = {
    total: "Итого",
    employee: "По сотрудникам",
    month: "По месяцам",
    day: "По дням",
};
